// @flow
import React, { Fragment } from "react";
import { Control, Input } from "biologiatotal-ui";
import InputDefaultMask from "../../../components/inputMask";
import { getCurrencyFormat } from "../../../components/utils/currency";
import "./billetForm.scss";
import Form from "../../../components/form";
import { Checkbox } from "../../../components/checkbox";

import formSchema from "./schema";

class BilletForm extends Form {
  constructor(props: any) {
    super(props, formSchema);

    this.state = {
      ...this.state
    };
  }

  componentDidMount() {
    const { errors } = this.state;
    const { validadeErrosForm } = this.props;

    const errorsForm = Object.entries(errors).filter(([key, value]) => value || (key === "terms" && value === false))
      .length;

    validadeErrosForm(errorsForm);
  }

  componentDidUpdate(prevProps, prevState) {
    const { errors } = this.state;
    const { validadeErrosForm } = this.props;

    if (prevState.errors && prevState.errors !== errors) {
      const errorsForm = Object.entries(errors).filter(([key, value]) => value || (key === "terms" && value === false))
        .length;

      validadeErrosForm(errorsForm);
    }
  }

  doPay() {
    const { onPay } = this.props;
    const values = this.getValues();

    // if (!values.terms) {
    //   this.setError("terms", "É obrigatório aceitar os termos de uso para assinar um plano");
    // } else {
    this.validate().then(
      () => onPay(values),
      () => null
    );
    // }
  }

  viaCep = cep => {
    const { doCepRequest } = this.props;

    if (cep.length === 10) {
      let cepReplaced = cep.replace(".", "");

      doCepRequest(cepReplaced)
        .then(json => {
          // Pega a cidade para os ceps que vem entre parenteses ex:(55165-000)
          const regExp = /\(([^)]+)\)/;
          const matches = regExp.exec(json.data.localidade);
          const localidade = matches ? matches[1] : json.data.localidade;

          this.update("cep", cepReplaced);
          this.update("address", json.data.logradouro);
          this.update("neighborhood", json.data.bairro);
          this.update("uf", json.data.uf);
          this.update("city", localidade);
        })
        .catch(err => {
          this.setError("cep", "CEP inválido");
        });
    }
  };

  render() {
    const { values, errors } = this.state;
    const { plan, isFetchingCep } = this.props;

    return (
      <Fragment>
        <div className="billet-panel-info-inputs">
          <div className="billet-panel-info-inputs-info">Campos obrigatórios</div>
        </div>
        <div className="billet-panel">
          <div className="field is-horizontal">
            <Control className="billet-panel-control billet-panel-control-pdr column is-6">
              <InputDefaultMask
                type="text"
                label="Qual o seu CPF?"
                mask={"999.999.999-99"}
                danger={!!errors.cpf}
                required={true}
                value={values.cpf}
                onChange={e => this.update("cpf", e.target.value)}
                placeholder="000.000.000-00"
                className="billet-panel-input"
              />
              <p className="billet-panel-info help is-danger">{errors.cpf}</p>
            </Control>

            <div className="billet-panel-mobile-control">
              <Control className="billet-panel-control billet-panel-control-pdl column is-8 is-8-mobile">
                <InputDefaultMask
                  type="text"
                  label="CEP:"
                  mask="99.999-999"
                  danger={!!errors.cep}
                  value={values.cep}
                  required={true}
                  loading={isFetchingCep ? "loading-mask" : ""}
                  onChange={e => this.viaCep(e.target.value)}
                  placeholder="00.000-000"
                  className="billet-panel-input"
                />
                <p className="billet-panel-info help is-danger">{errors.cep}</p>
              </Control>

              <Control className="billet-panel-control billet-panel-control-pdl  column is-4 is-4-mobile credit-card-control-cep">
                <a
                  title="não sei o CEP"
                  href={"http://www.buscacep.correios.com.br/sistemas/buscacep/"}
                  target={"_blank"}
                  className={" credit-card-control-cep-link"}>
                  não sei o CEP
                </a>
              </Control>
            </div>
          </div>

          <div className="field is-horizontal">
            <Control className="billet-panel-control billet-panel-control-pdr column is-6">
              <span className={`billet-panel-label input-required ${!!errors.address ? "error-input" : ""}`}>Rua:</span>
              <Input
                type="text"
                value={values.address}
                danger={!!errors.address}
                aria-label="Rua"
                onChange={e => this.update("address", e.target.value)}
                disabled={isFetchingCep ? "disabled" : ""}
                placeholder="Nome da rua"
                className="billet-panel-input"
                maxLength="60"
              />
              <p className="billet-panel-info help is-danger">{errors.address}</p>
            </Control>

            <Control className="billet-panel-control billet-panel-control-pdm column is-2">
              <span className={`billet-panel-label not-required`}>Número:</span>
              <Input
                type="text"
                value={values.numberAddress}
                danger={!!errors.numberAddress}
                aria-label="Número"
                onChange={e => this.update("numberAddress", e.target.value)}
                placeholder="000"
                className="billet-panel-input"
                maxLength="9"
              />
              <p className="billet-panel-info help is-danger">{errors.numberAddress}</p>
            </Control>

            <Control className="billet-panel-control billet-panel-control-pdl column is-4">
              <span className="billet-panel-label">Complemento:</span>
              <Input
                type="text"
                value={values.comp}
                danger={!!errors.comp}
                onChange={e => this.update("comp", e.target.value)}
                placeholder="Complemento"
                aria-label="Complemento"
                className="billet-panel-input"
                maxLength="30"
              />
              <p className="billet-panel-info help is-danger">{errors.comp}</p>
            </Control>
          </div>

          <div className="field is-horizontal">
            <Control className="billet-panel-control billet-panel-control-pdr column is-6">
              <span className={`billet-panel-label input-required ${!!errors.address ? "error-input" : ""}`}>
                Bairro:
              </span>
              <Input
                type="text"
                value={values.neighborhood}
                danger={!!errors.neighborhood}
                onChange={e => this.update("neighborhood", e.target.value)}
                disabled={isFetchingCep ? "disabled" : ""}
                placeholder="Bairro"
                aria-label="Bairro"
                className="billet-panel-input"
                maxLength="50"
              />
              <p className="billet-panel-info help is-danger">{errors.neighborhood}</p>
            </Control>

            <Control className="billet-panel-control billet-panel-control-pdm column is-2">
              <span className={`billet-panel-label input-required ${!!errors.address ? "error-input" : ""}`}>UF:</span>
              <Input
                type="text"
                value={values.uf}
                danger={!!errors.uf}
                onChange={e => this.update("uf", e.target.value)}
                disabled={isFetchingCep ? "disabled" : ""}
                placeholder="UF"
                aria-label="UF"
                className="billet-panel-input"
                maxLength="2"
                minLength="2"
              />
              <p className="billet-panel-info help is-danger">{errors.uf}</p>
            </Control>

            <Control className="billet-panel-control billet-panel-control-pdl column is-4">
              <span className={`billet-panel-label input-required ${!!errors.address ? "error-input" : ""}`}>
                Cidade:
              </span>
              <Input
                type="text"
                value={values.city}
                danger={!!errors.city}
                onChange={e => this.update("city", e.target.value)}
                disabled={isFetchingCep ? "disabled" : ""}
                placeholder="Cidade"
                aria-label="Cidade"
                className="billet-panel-input"
              />
              <p className="billet-panel-info help is-danger">{errors.city}</p>
            </Control>
          </div>

          {plan && plan.installment_count === 1 && (
            <Control className="billet-panel-control column is-12">
              <Checkbox
                value={values.recurrence}
                ariaLabel="Quero que a cobrança seja renovada automaticamente todos os meses"
                onChange={value => this.update("recurrence", value)}>
                Quero que a cobrança seja renovada automaticamente todos os meses
                <span className="billet-panel-msgrecurrence">
                  Isso significa que o valor de {getCurrencyFormat(plan.installment_value, "R$ ").replace(".", ",")}{" "}
                  será cobrado todos os meses
                </span>
              </Checkbox>
            </Control>
          )}

          <span className="column is-12 billet-panel-notification">
            <span className="billet-panel-notification-title">Atenção</span>
            <span className="billet-panel-notification-content">
              Devido ao tempo de processamento dos boletos, o banco pode levar até 3 dias úteis para reconhecer o
              pagamento e nos informar. Até lá, você terá acesso aos itens gratuitos da plataforma e após receber a
              confirmação, liberamos seu acesso completo!
            </span>
          </span>
        </div>
      </Fragment>
    );
  }
}

BilletForm.displayName = "BilletForm";

export default BilletForm;
